import { getZPLCommandWithCustomTemplate } from "./getZplCommandWithCustomTemplate";

export default getZPLCommandWithCustomTemplate;
